import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Row, Button, Input } from 'antd';
import { Controller, useForm } from 'react-hook-form';

import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import GetField from '../Components/GetField';
import { getWorker, clearWorker } from '../Actions';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntInputTextArea = GetField(Input.TextArea);

const UpdateWorker = props => {
  const { classes, match } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control, reset } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const worker = useSelector(state => state.worker);

  useEffect(() => {
    dispatch(getWorker(match.params.id));

    return () => {
      dispatch(clearWorker());
    };
  }, []);

  useEffect(() => {
    reset(worker);
  }, [worker]);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.put(`/workers/${match.params.id}`, formValues);
      successNotification('Worker updated');
      history.push('/workers/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Worker"
        moduleLink="/workers/list"
        subModuleName="Update"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Email"
                  placeholder="Email"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Phone"
                  placeholder="Phone"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Address"
                  placeholder="Address"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="comment"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="employeeId"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Employee Id"
                  placeholder="Employee Id"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Update
          </Button>
        </Row>
      </form>
    </>
  );
};

UpdateWorker.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpdateWorker);
